<script setup>
import { ref } from "vue";
import Chevron from "../components/Chevron.vue";
import { RouterLink } from "vue-router";

const expanded = ref(false);

const containerRef = ref(null);

function handleExpand() {
  expanded.value = true;

  if (containerRef.value) {
    setTimeout(() => {
      window.scrollTo({
        top: 10000,
        behavior: "smooth",
      });
    }, 100);
  }
}
</script>

<template>
  <div class="container" ref="containerRef" :class="{ expanded: expanded }">
    <div class="max-w-[1200px] mx-auto flex flex-col lg:gap-x-20 gap-y-10">
      <div class="flex flex-col lg:flex-row gap-10 order-2 lg:order-1">
        <RouterLink to="/stichting" class="link-box">
          <img class="logo" src="../assets/stichting-logo.png" />
          <button class="flex items-center gap-x-4">
            <h3>De stichting</h3>
            <Chevron class="text-black h-5 w-5 transition-all" />
          </button>
        </RouterLink>
        <RouterLink to="/vastgoed" class="link-box">
          <img class="logo" src="../assets/logo.png" />
          <button class="flex items-center gap-x-4">
            <h3>Vastgoedbeheer</h3>
            <Chevron class="text-black h-5 w-5 transition-all" />
          </button>
        </RouterLink>
      </div>
      <div
        class="p-6 sm:p-8 mx-auto bg-sand order-1 lg:order-2"
        @click="handleExpand"
      >
        <h3 class="mb-4 text-black text-center">Wie is PSDF?</h3>
        <p class="text-black">
          Property Support Development Fund (PSDF) ontwikkelt en beheert
          vastgoed voor maatschappelijke en sociale organisaties, zoals
          bijvoorbeeld kerken, zorginstellingen en organisaties voor sport en
          activiteit. Voor deze organisaties is het realiseren en beheren van
          passende huisvesting vaak lastig. Onder meer door beperkte kennis en
          <span class="break-all">financieringsmogelijkheden</span>.
          <br />
          <br />
        </p>
        <button
          v-if="!expanded"
          @click="handleExpand"
          class="flex items-center gap-x-2"
        >
          Lees meer
          <Chevron class="text-black h-5 w-5 transition-all" />
        </button>
        <p v-else>
          Maatschappelijke organisaties faciliteren met passende huisvesting,
          zowel vandaag als in de toekomst: dat is wat PSDF wil doen.
          Duurzaamheid, (financiële) draagkracht van de gebruiker op lange
          termijn, en een toekomstbestendige ontwerpstrategie zijn daarbij
          belangrijke uitgangspunten.
        </p>
      </div>
    </div>
  </div>
</template>
<style scoped>
.link-box {
  @apply flex flex-col items-center justify-center gap-6 sm:justify-between p-8 sm:p-20;
  @apply w-full bg-sand;
}

.link-box .logo {
  @apply w-[200px] h-[100px] object-contain;
  @apply object-contain;
}

.link-box:hover svg {
  @apply translate-x-1;
}

.container {
  @apply bg-white max-h-screen h-screen min-w-full overflow-y-scroll gap-y-6 p-4 sm:p-10 transition-all duration-300;
}

.container.expanded {
  max-height: 2000px;
}
</style>
